import extractDataFromFirebaseCredential from 'lib/extractDataFromFirebaseCredential';

import User from 'types/User';
import { signInWithEmailAndPassword } from 'lib/Auth';

export default async function signInWithEmailAndPasswordUseCase(
  email: string,
  password: string
): Promise<User> {
  const credential = await signInWithEmailAndPassword(email, password);
  return extractDataFromFirebaseCredential(credential);
}
